import {withRouter} from "react-router-dom";
import React, { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import {GenericContext, InstallationsContext} from "./App";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SITE_LINKS} from "../Contants";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faBell} from "@fortawesome/free-solid-svg-icons/faBell";
import {
  ALERT_CODE_TECH_ALARM,
  ALERT_CODE_TECH_WARNING,
  ALERT_TYPE_TECH_ALARM,
  ALERT_TYPE_TECH_WARNING,
  IGNORE_TECH_ALERTS_ALARMS,
  IGNORE_TECH_ALERTS_WARNINGS,
  // INSTALLATION_ALERT_STATUS_DISCONNECTED,
  INSTALLATION_MODE_DISABLED,
  INSTALLATION_MODE_MAINTENANCE
} from "../api/wimhome-api";

export default withRouter(function AlertsBar(props) {
  const {history} = props;
  const {t/*, i18n*/} = useTranslation();
  const {
    selectedInst,
    handleSelectInstallation,
    installations,
    acknowledgeAlerts,
    // alerts,
    alertCodes
  } = React.useContext(InstallationsContext);
  const { userOptions } = React.useContext(GenericContext);

  let [alarms, setAlarms] = useState([]);
  let [warnings, setWarnings] = useState([]);
  let [techAlarms, setTechAlarms] = useState( []);
  let [techWarnings, setTechWarnings] = useState( []);

  function jumpToInstallation(serial, alertsToMark) {
    if(serial === null) {
      handleSelectInstallation(serial);
      history.push(SITE_LINKS.INSTALLATIONS);
      return;
    }

    acknowledgeAlerts(serial, alertsToMark);

    if(serial === selectedInst)
      return;
    handleSelectInstallation(serial);
    history.push(SITE_LINKS.STATUS);
  }

  useEffect(() => {
    if(userOptions?.showPermanentAlertsBar !== 1)
      return;

    let newAlarms = [];
    let newWarnings = [];
    let newTechAlarms = [];
    let newTechWarnings = [];

    Object.values(installations ?? new Map()).forEach((inst) => {
      inst.alerts.forEach( (alert) => {
        if(inst.mode !== INSTALLATION_MODE_DISABLED && inst.mode !== INSTALLATION_MODE_MAINTENANCE) {
          if(alert.value > 0) {
            if (alertCodes != null && alertCodes?.has(alert.code)) {
              if (alertCodes.get(alert.code).type === ALERT_TYPE_TECH_ALARM) {
                if(!(userOptions?.ignoreTechAlerts & IGNORE_TECH_ALERTS_ALARMS))
                  newTechAlarms.push({...alert, instSerial: inst.id});
              }
              else if (alertCodes.get(alert.code).type === ALERT_TYPE_TECH_WARNING) {
                if(!(userOptions?.ignoreTechAlerts & IGNORE_TECH_ALERTS_WARNINGS))
                  newTechWarnings.push({...alert, instSerial: inst.id});
              }
              else if (alert.type === 1)
                newWarnings.push({...alert, instSerial: inst.id});
              else if (alert.type === 2)
                newAlarms.push({...alert, instSerial: inst.id});
            } else {
              if (alert.code === ALERT_CODE_TECH_ALARM) {
                if(!(userOptions?.ignoreTechAlerts & IGNORE_TECH_ALERTS_ALARMS))
                  newTechAlarms.push({...alert, instSerial: inst.id});
              } else if (alert.code === ALERT_CODE_TECH_WARNING) {
                if(!(userOptions?.ignoreTechAlerts & IGNORE_TECH_ALERTS_WARNINGS))
                  newTechWarnings.push({...alert, instSerial: inst.id});
              } else if (alert.type === 1)
                newWarnings.push({...alert, instSerial: inst.id});
              else if (alert.type === 2)
                newAlarms.push({...alert, instSerial: inst.id});
            }
          }
        }
      });
    });

    setAlarms(newAlarms);
    setWarnings(newWarnings);
    setTechAlarms(newTechAlarms);
    setTechWarnings(newTechWarnings);
  }, [installations, userOptions]);

  if(userOptions?.showPermanentAlertsBar !== 1)
    return null;

  // console.log('Alarms: ', alarms);
  // console.log('Warnings: ', warnings);

  let styleClass = "alert-bar-permanent-ok";
  let icon = faCheck;
  let message = t('alerts.permBarNoAlarm');
  if(alarms.length > 0) {
    styleClass = "alert-bar-permanent-alarm";
    message = `${alarms.length} ${t(alarms.length === 1 ? 'alerts.permBarAlarms1' : 'alerts.permBarAlarmsN')}`;
    icon = faBell;
  }
  else if(warnings.length > 0) {
    styleClass = "alert-bar-permanent-warning";
    message = `${warnings.length} ${t(warnings.length === 1 ? 'alerts.permBarWarnings1' : 'alerts.permBarWarningsN')}`;
    icon = faBell;
  }

  if(techAlarms.length > 0) {
    message += ` (${techAlarms.length} ${t(techAlarms.length === 1 ? 'alerts.permBarTechAlarms1' : 'alerts.permBarTechAlarmsN')})`;
  }

  if(techWarnings.length > 0) {
    message += ` (${techWarnings.length} ${t(techWarnings.length === 1 ? 'alerts.permBarTechWarnings1' : 'alerts.permBarTechWarningsN')})`;
  }

  return (
      <>
        <div
            className={"alert-bar-permanent " + styleClass}
            onClick={() => {jumpToInstallation(null, null)}}
        >
          <p><FontAwesomeIcon className="taker-control-bell" icon={icon}/> {`${message}`}</p>
      </div>
      </>
  );
})